import { useState } from 'react';
import apiService from '../../axios/apiService';
import { useLocation } from 'react-router-dom';
import { getSearchParamFromLocation } from '../../utils/mapper';
import { message } from 'antd';

export const useInvoiceServiceDelete = () => {
  const [loading, setLoading] = useState(false);
  const [recordId, setRecordId] = useState(undefined);
  const location = useLocation();
  const deleteInvoiceService = async (invoiceServiceId) => {
    // Delete invoice service
    setLoading(true);
    setRecordId(invoiceServiceId);
    try {
      const invoiceId = getSearchParamFromLocation('id', location);
      if (!invoiceId || !invoiceServiceId) {
        return message.error('Please provide invoice ID');
      }
      const response = await apiService.deleteInvoiceService(
        invoiceId,
        invoiceServiceId
      );
      return response;
    } catch (error) {
      message.error(error.response.data.message);
    } finally {
      setLoading(false);
      setRecordId(undefined);
    }
  };

  return {
    loading,
    recordId,
    deleteInvoiceService,
  };
};
